import React from 'react';
import { useIntl } from 'react-intl';
import { MenuItem } from './MenuItem';
import { useLocation, useNavigate } from 'react-router-dom';

export function MenuInner() {
  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();

  const titleStyle = {
    fontSize: '24px',
    fontWeight: 600,
    letterSpacing: '0.02em',
  };

  const handleBackClick = () => {
    const currentPath = location.pathname;
    
    if (currentPath === '/outpatient') {
      navigate('/builder', { 
        state: { 
          defaultClaimType: 'OUTPATIENT',
          defaultDisplayText: 'Rawat Jalan'
        } 
      });
    } else if (currentPath === '/inpatient') {
      navigate('/builder', { 
        state: { 
          defaultClaimType: 'INPATIENT',
          defaultDisplayText: 'Rawat Inap'
        } 
      });
    } else {
      navigate('/builder');
    }
  };

  const getTitle = () => {
    let dynamicTitle = '';

    switch (location.pathname) {
      case '/outpatient':
        dynamicTitle = intl.formatMessage({ id: 'Pengesahan' });
        break;
      case '/inpatient':
        dynamicTitle = intl.formatMessage({ id: 'Diagnosis' });
        break;
      case '/builder':
        dynamicTitle = intl.formatMessage({ id: 'Claim Management' });
        break;
      case '/settlement':
        dynamicTitle = intl.formatMessage({ id: 'Claim Settlement' });
        break;
      case '/settlement-detail':
        dynamicTitle = intl.formatMessage({ id: 'Settlement Detail' });
        break;
      default:
        dynamicTitle = '';
    }

    return dynamicTitle
      ? `${dynamicTitle}`
      : intl.formatMessage({ id: 'Home' });
  };

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0' }}>
        {(location.pathname === '/inpatient' || location.pathname === '/outpatient') && (
          <button 
            onClick={handleBackClick} 
            style={{ 
              background: 'none', 
              border: 'none', 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <span style={{ fontSize: '18px', marginRight: '8px' }}>&#8592;</span>
          </button>
        )}
      </div>
      <MenuItem title={getTitle()} to='/dashboard' titleStyle={titleStyle} />
    </>
  );
}